<script lang="ts">
    import { Col,Badge } from "sveltestrap";
    import Card from "../UiCommenCard.svelte";
    import {Contextualvariation, Danger, Dark, Info, Light, Primary, Secondary, Success, Warning} from "../../../utils/Constant/Constant"
</script>

<Col sm="12" md="6">
    <Card cardHeaderprops="pb-0" headerTitle={Contextualvariation}>
        <div slot="contentbody">
            <Badge color="primary">{Primary}</Badge>
            <Badge color="secondary">{Secondary}</Badge>
            <Badge color="success">{Success}</Badge>
            <Badge color="info">{Info}</Badge>
            <Badge color="warning" class="text-dark">{Warning}</Badge>
            <Badge color="danger">{Danger}</Badge>
            <Badge color="light" class="text-dark">{Light}</Badge>
            <Badge color="dark" class="tag-pills-sm-mb">{Dark}</Badge>
        </div>
    </Card>
</Col>
<Col sm="12" md="6">
    <Card cardHeaderprops="pb-0" headerTitle={Contextualvariation}>
        <div slot="contentbody">
            <Badge pill color="primary">{Primary}</Badge>
            <Badge pill color="secondary">{Secondary}</Badge>
            <Badge pill color="success">{Success}</Badge>
            <Badge pill color="info">{Info}</Badge>
            <Badge pill color="warning" class="text-dark">{Warning}</Badge>
            <Badge pill color="danger">{Danger}</Badge>
            <Badge pill color="light" class="text-dark">{Light}</Badge >
            <Badge pill color="dark" class="tag-pills-sm-mb">{Dark}</Badge>
        </div>
    </Card>
</Col>
